import { Link } from "react-router-dom";
import AdminListCoverThumb from "../AdminListCoverThumb";
import { expertiseNamesFromClip } from "./clipExpertiseUtils";

function accessSummary(clip) {
	if (clip.access_type === "free") return "رایگان";
	if (clip.access_type === "subscription") return "اشتراک";
	return `${clip.credit_cost || 0} اعتبار`;
}

export default function AdminVideoClipListItem({
	clip,
	isEditing,
	onEdit,
	onRemove,
}) {
	const expertiseNames = expertiseNamesFromClip(clip);
	const instructorNames = (clip.instructors_detail ?? [])
		.map((item) => item?.name)
		.filter(Boolean)
		.join("، ");

	return (
		<article
			className={[
				"flex flex-col gap-3 rounded-[12px] border bg-white p-4 transition sm:flex-row sm:items-center sm:justify-between",
				isEditing
					? "border-cta/40 ring-2 ring-cta/20 shadow-[0_4px_16px_rgba(255,106,75,0.12)]"
					: "border-darkBlue/10 hover:border-darkBlue/20",
			].join(" ")}
		>
			<div className="min-w-0 flex-1 text-right">
				<div className="flex flex-wrap items-start gap-3">
					<AdminListCoverThumb
						src={clip.image_url}
						alt={clip.title}
						showWhenEmpty
					/>
					<div className="min-w-0 flex-1">
						<div className="flex flex-wrap items-center gap-2">
							<h3 className="font-Vazir-700 text-[15px] text-darkBlue">
								{clip.title}
							</h3>
							{!clip.is_active && (
								<span className="rounded-full bg-red-50 px-2 py-0.5 font-Vazir-600 text-[11px] text-red-600">
									مخفی
								</span>
							)}
							{isEditing && (
								<span className="rounded-full bg-cta/10 px-2 py-0.5 font-Vazir-600 text-[11px] text-cta">
									در حال ویرایش
								</span>
							)}
						</div>
						{instructorNames ? (
							<p className="mt-1 font-Vazir-400 text-[12px] text-darkBlue/55 line-clamp-1">
								استاد: {instructorNames}
							</p>
						) : (
							<p className="mt-1 font-Vazir-400 text-[12px] text-darkBlue/45">
								استاد ثبت نشده
							</p>
						)}
					</div>
				</div>
				<div className="mt-2 flex flex-wrap gap-2">
					<span className="rounded-[8px] bg-lightCta px-2.5 py-1 font-Vazir-600 text-[12px] text-darkBlue">
						{accessSummary(clip)}
					</span>
					{clip.has_video_file && (
						<span className="rounded-[8px] bg-darkBlue/5 px-2.5 py-1 font-Vazir-500 text-[12px] text-darkBlue/70">
							فایل ویدیو
						</span>
					)}
					{clip.video_url && !clip.has_video_file && (
						<span className="rounded-[8px] bg-darkBlue/5 px-2.5 py-1 font-Vazir-500 text-[12px] text-darkBlue/70">
							لینک ویدیو
						</span>
					)}
					{!clip.has_video_file && !clip.video_url && (
						<span className="rounded-[8px] bg-amber-50 px-2.5 py-1 font-Vazir-500 text-[12px] text-amber-800">
							بدون ویدیو
						</span>
					)}
				</div>
				{expertiseNames.length > 0 && (
					<p className="mt-2 font-Vazir-400 text-[12px] text-darkBlue/65 line-clamp-1">
						تخصص: {expertiseNames.join("، ")}
					</p>
				)}
			</div>
			<div className="flex shrink-0 flex-wrap gap-2 sm:justify-end">
				<Link
					to={`/video_clip_detail/${clip.id}/`}
					target="_blank"
					rel="noopener noreferrer"
					className="rounded-[10px] border border-darkBlue/15 px-3 py-2 font-Vazir-600 text-[13px] text-darkBlue no-underline transition hover:border-darkBlue/30"
				>
					مشاهده
				</Link>
				<button
					type="button"
					onClick={() => onEdit(clip)}
					className="rounded-[10px] bg-lightCta px-4 py-2 font-Vazir-600 text-[13px] text-darkBlue transition hover:bg-[#E0EEF8]"
				>
					ویرایش
				</button>
				<button
					type="button"
					onClick={() => onRemove(clip)}
					className="rounded-[10px] border border-red-200 px-4 py-2 font-Vazir-600 text-[13px] text-red-600 transition hover:bg-red-50"
				>
					حذف
				</button>
			</div>
		</article>
	);
}
